import { CircleHelp } from 'lucide-react';
import { GUIDE_STEPS, useReguideTarget } from '#stores/ReguideContext';

const HelpButton = ({ onClick }: { onClick: () => void }) => {
  const targetRef = useReguideTarget<HTMLButtonElement>(GUIDE_STEPS.HELP_GUIDE);

  return (
    <button
      ref={targetRef}
      type="button"
      className="btn btn-primary btn-circle fixed bottom-5 right-5 z-40 shadow-lg"
      aria-label="Open help guide"
      title="Help guide"
      data-reguide-target={GUIDE_STEPS.HELP_GUIDE}
      onClick={onClick}
    >
      <CircleHelp className="h-6 w-6" />
    </button>
  );
};

export default HelpButton;
